import React, {useEffect} from 'react';
import {useDispatch} from "react-redux";
import {setAnimating, setAnimatingComplete} from '../store/reducers/questionReducer';

interface IProps {
    chatAnswer: any;
    initialDelay: number;
    wordDelay: number;
    classNameBeforeDelay: string;
    classNameAfterDelay: string;
    identifier: string
}

function ChatAnimation(props: IProps) {
    const {
        chatAnswer,
        initialDelay = 0,
        wordDelay = 0.2,
        classNameBeforeDelay,
        classNameAfterDelay,
        identifier
    } = props;
    const dispatch = useDispatch();
    const [displayText, setDisplayText] = React.useState('');
    const [chatClassName, setChatClassName] = React.useState(classNameBeforeDelay);
    React.useEffect(() => {
        const splitText = chatAnswer.split(' ');

        const timer = setTimeout(() => {
            let totalDelay = splitText.length * wordDelay;
            totalDelay = totalDelay * 1000 + 3000;
            setDisplayText(
                splitText.map((word: string, wordIndex: number) => {
                    let words = (word && word.length > 0) ? word.replace(/\n/g, '<br/>') : word;
                    return <span
                        key={wordIndex}
                        className={`fade-in-word ${classNameAfterDelay}`}
                        style={{animationDelay: `${(wordIndex * wordDelay).toFixed(1)}s`}}
                        dangerouslySetInnerHTML={{__html: words + ' '}}
                    >
                      
                    </span>
                })
            );
            setChatClassName(classNameAfterDelay)
            setTimeout(() => {
                dispatch(setAnimatingComplete(identifier));
            }, totalDelay)
        }, initialDelay * 1000);

        return () => clearTimeout(timer);
    }, [chatAnswer, initialDelay, wordDelay, classNameAfterDelay]);

    useEffect(() => {
        dispatch(setAnimating(identifier));
    }, []);

    return (
        <div className={chatClassName}>
            {displayText}
        </div>
    );
}

export default ChatAnimation;

